import { render, staticRenderFns } from "./WorkflowItemTypeAndParams.vue?vue&type=template&id=63a0d551&scoped=true&"
import script from "./WorkflowItemTypeAndParams.vue?vue&type=script&lang=js&"
export * from "./WorkflowItemTypeAndParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0d551",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a0d551')) {
      api.createRecord('63a0d551', component.options)
    } else {
      api.reload('63a0d551', component.options)
    }
    module.hot.accept("./WorkflowItemTypeAndParams.vue?vue&type=template&id=63a0d551&scoped=true&", function () {
      api.rerender('63a0d551', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkflowItemTypeAndParams.vue"
export default component.exports